import { render } from "./PriceOneAverages.vue?vue&type=template&id=2b9049a4&scoped=true"
import script from "./PriceOneAverages.vue?vue&type=script&lang=js"
export * from "./PriceOneAverages.vue?vue&type=script&lang=js"

import "./PriceOneAverages.vue?vue&type=style&index=0&id=2b9049a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9049a4"]])

export default __exports__